import React, { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';

import SidebarNav from './SidebarNav';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/Store';
import ConfigDB from '../../config/ThemeConfig';
import { setSideBarToggle } from '../../store/reducers/Layout/LayoutReducer';

export default function Sidebar() {
   const dispatch = useDispatch();
   const { sideBarToggle } = useSelector((state: RootState) => state.layout);
   const wrapper = ConfigDB.settings.sidebar.type;
   const [margin, setMargin] = useState(0);
   const [leftArrow, setLeftArrow] = useState(true);
   const sidebarIconType = useSelector(
      (state: RootState) => state.themeCustomizer.sideBarIconType
   );
   const sideBarIcon = sidebarIconType || ConfigDB.settings.sidebar.iconType;

   useEffect(() => {
      if (!sideBarToggle) {
         // Wait 350ms for the slide-in sidebar animation to complete
         const timer = setTimeout(() => {
            const menuContainer = document.querySelector('.sidebar-menu');
            const activeElement = document.querySelector(
               '.sidebar-menu .sidebar-link.active, .sidebar-menu .submenu-title.active'
            ) as HTMLElement;

            if (menuContainer && activeElement) {
               const containerRect = menuContainer.getBoundingClientRect();
               const elementRect = activeElement.getBoundingClientRect();
               
               // Get absolute top of the element relative to scrollable container
               const relativeTop = elementRect.top - containerRect.top + menuContainer.scrollTop;
               const containerHeight = menuContainer.clientHeight;
               const elementHeight = activeElement.clientHeight;

               menuContainer.scrollTo({
                  top: relativeTop - containerHeight / 2 + elementHeight / 2,
                  behavior: 'smooth',
               });
            }
         }, 350);

         return () => clearTimeout(timer);
      }
   }, [sideBarToggle]);

   const scrollToRight = () => {
      if (margin > -3000) {
         setMargin((prevMargin) => prevMargin - 500);
         setLeftArrow(false);
      }
   };
   const scrollToLeft = () => {
      setMargin((prevMargin) => prevMargin + 500);
      if (margin === -600) {
         setMargin(0);
         setLeftArrow(true);
      }
   };
   return (
      <>
         <aside
            className={`page-sidebar ${sideBarToggle ? 'close_icon' : ''} ${sideBarIcon === 'iconcolor-sidebar' ? 'iconcolor-sidebar' : ''}`}
            data-sidebar-layout={sideBarIcon}
         >
            <div className="mobile-sidebar-header d-flex d-lg-none">
               <span>Menú de Opciones</span>
               <button 
                  type="button" 
                  className="btn-close shadow-none" 
                  onClick={() => dispatch(setSideBarToggle(true))}
               />
            </div>
            <div
               className={`left-arrow ${leftArrow ? 'disabled' : ''}`}
               id="left-arrow"
               onClick={scrollToLeft}
            >
               <ArrowLeft />
            </div>
            <div
               className="main-sidebar"
               id="main-sidebar"
               style={{ marginLeft: margin + 'px' }}
            >
               <SidebarNav />
            </div>
            {wrapper === 'horizontal-sidebar' && (
               <div
                  className="right-arrow"
                  onClick={scrollToRight}
                  id="right-arrow"
               >
                  <ArrowRight />
               </div>
            )}
         </aside>
      </>
   );
}
